"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = require("@apollo/client/link/error");
const log_1 = require("@aurora/shared-utils/log");
const SwitchUserHelper_1 = require("./helpers/SwitchUserHelper");
const ToggleTextKeysHelper_1 = require("./helpers/ToggleTextKeysHelper");
const log = (0, log_1.getLog)(module);
/**
 * Builds an error link.
 * @param tenant
 * @param clearCookies Clear cookies on unauthenticated error
 */
function getErrorLink(tenant, clearCookies = true) {
    return (0, error_1.onError)((errorResponse) => {
        // if no tenant, requests will fail.  No point in logging that until a tenant is chosen.
        const { host } = tenant;
        if (host) {
            const { graphQLErrors } = errorResponse;
            const unauthenticatedError = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.filter(item => { var _a; return ((_a = item.extensions) === null || _a === void 0 ? void 0 : _a.code) === 'UNAUTHENTICATED'; });
            // If there is an unauthenticated error we proactively clear any switch user cookie.
            if (clearCookies === true && (unauthenticatedError === null || unauthenticatedError === void 0 ? void 0 : unauthenticatedError.length) > 0) {
                (0, SwitchUserHelper_1.clearSwitchUserIdCookie)();
                (0, ToggleTextKeysHelper_1.clearToggleTextKeysEnabledUserIdCookie)();
            }
            if (process.env.NODE_ENV === 'development') {
                // Delete the query since it's very large and not helpful for debugging.
                delete errorResponse.operation.query;
                log.error('[GraphQL error]: %O', errorResponse);
            }
            else {
                if (graphQLErrors) {
                    graphQLErrors.forEach(({ message, locations, path }) => {
                        var _a;
                        log.error('[GraphQL error]: Message: %s, Locations: $O, Path: %O, Operation: %s', message, locations !== null && locations !== void 0 ? locations : [], path, (_a = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.operation) === null || _a === void 0 ? void 0 : _a.operationName);
                    });
                }
            }
        }
    });
}
exports.default = getErrorLink;
//# sourceMappingURL=errorLink.js.map